import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import AppLayout from './components/layout/AppLayout';
import PasswordGate from './components/auth/PasswordGate';

// Pages & Features
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import CommunityPage from './pages/CommunityPage';
import PilatesSessionPage from './features/session/PilatesSessionPage';
import AboutPage from './features/about/AboutPage';
import CardSequencesPage from './pages/CardSequencesPage';
import MyPage from './pages/MyPage';
import BookingPage from './pages/BookingPage';
import NewsPage from './features/news/NewsPage';
import QAPage from './pages/QAPage';
import ContactPage from './pages/ContactPage';
import SuccessPage from './pages/SuccessPage';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <PasswordGate>
      <AppLayout onToggleMenu={() => setIsMenuOpen(!isMenuOpen)}>
        <Routes>
          <Route path="/" element={<HomePage isMenuOpen={isMenuOpen} />} />
          <Route path="/login" element={<LoginPage isMenuOpen={isMenuOpen} />} />
          <Route path="/community" element={<CommunityPage isMenuOpen={isMenuOpen} />} />
          <Route path="/session" element={<PilatesSessionPage isMenuOpen={isMenuOpen} />} />
          <Route path="/about" element={<AboutPage isMenuOpen={isMenuOpen} />} />
          <Route path="/cards" element={<CardSequencesPage isMenuOpen={isMenuOpen} />} />
          <Route path="/mypage" element={<MyPage isMenuOpen={isMenuOpen} />} />
          <Route path="/booking" element={<BookingPage isMenuOpen={isMenuOpen} />} />
          <Route path="/news" element={<NewsPage isMenuOpen={isMenuOpen} />} />
          <Route path="/qa" element={<QAPage isMenuOpen={isMenuOpen} />} />
          <Route path="/contact" element={<ContactPage isMenuOpen={isMenuOpen} />} />
          <Route path="/success" element={<SuccessPage isMenuOpen={isMenuOpen} />} />
        </Routes>
      </AppLayout>
    </PasswordGate>
  );
}

export default App;